// Shared TanStack QueryClient. The retry policy intentionally only retries
// server-side failures (5xx) — client-side 4xx errors are deterministic and
// retrying them just wastes a network round-trip + delays the error UI.
//
// Duration constants are inlined as private consts: per architecture-principles
// §11, core/ must not import from shared/. Shared exports the same MS
// constants for feature consumers; keep them in sync if the cache windows
// change.

import { QueryClient } from '@tanstack/vue-query'
import type { AppError } from '@core/api/normalizeError'

const ONE_MINUTE_MS = 60_000
const FIVE_MINUTES_MS = 5 * 60_000
const MAX_RETRIES = 2
const SERVER_ERROR_STATUS_MIN = 500

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: ONE_MINUTE_MS,
      gcTime: FIVE_MINUTES_MS,
      refetchOnWindowFocus: false,
      retry: (count, err) =>
        count < MAX_RETRIES && ((err as AppError)?.statusCode ?? 0) >= SERVER_ERROR_STATUS_MIN,
    },
  },
})
